import _ from 'lodash';
import formatStateroomsForRequest from './formatters/formatStateroomsForRequest';

const getPriceBreakdownKey = ({ itineraryId, cruiseLineId, searchInputs }) => {
  const stateroomsStr = _.map(searchInputs, (s, index) => {
    let stateroom = '';
    if (s && s.searchInput) {
      const searchInput = formatStateroomsForRequest(s.searchInput, cruiseLineId);
      if (searchInput.adults) stateroom += `&room[${index}].adults=${searchInput.adults}`;
      if (searchInput.seniors) stateroom += `&room[${index}].seniors=${searchInput.seniors}`;
      if (searchInput.lapInfants)
        stateroom += `&room[${index}].lapInfants=${searchInput.lapInfants}`;
      if (searchInput.seatInfants)
        stateroom += `&room[${index}].seatInfants=${searchInput.seatInfants}`;
      if (searchInput.children)
        stateroom += `&room[${index}].children=${Object.values((s && searchInput && searchInput.children) || {}).join(',')}`;

      if (searchInput.pastPassengerNumber)
        stateroom += `&room[${index}].pastPassengerNumber=${searchInput.pastPassengerNumber}`;
      if (searchInput.pastPassengerNumber && searchInput.passengerFirstName)
        stateroom += `&room[${index}].passengerFirstName=${searchInput.passengerFirstName}`;
      if (searchInput.pastPassengerNumber && searchInput.passengerMiddleName)
        stateroom += `&room[${index}].passengerMiddleName=${searchInput.passengerMiddleName}`;
      if (searchInput.pastPassengerNumber && searchInput.passengerLastName)
        stateroom += `&room[${index}].passengerLastName=${searchInput.passengerLastName}`;

      if (searchInput.passengerOccupation)
        stateroom += `&room[${index}].passengerOccupation=${searchInput.passengerOccupation}`;
    }
    if (s.passengersPreferences) {
      _.forEach(s.passengersPreferences, (p) => {
        if (p.packages && p.packages[0]) {
          stateroom += `&p[${p.passengerIndex}].packages=${_.map(_.orderBy(p.packages, ['code', 'type', 'nights'], ['asc']), (pk) => `${pk.code}-${pk.type}-${pk.nights}`)}`;
        }
        if (p.specialServices && p.specialServices[0]) {
          stateroom += `&p[${p.passengerIndex}].services=${_.map(_.orderBy(p.specialServices, ['code', 'type', 'date', 'years'], ['asc']), (pk) => `${pk.code}-${pk.type}-${pk.date}-${pk.years}`)}`;
        }
        if (p.insuranceCoverage) {
          stateroom += `&p[${p.passengerIndex}].insuranceCoverage`;
        }
        if (p.cruiseTransportPreference) {
          stateroom += `&p[${p.passengerIndex}].cruiseTransport=${p.cruiseTransportPreference.mode}-${p.cruiseTransportPreference.cityCode}`;
        }
      });
    }
    return `${(s && s.rateOptionCode) || ''}&${(s && s.cabinCategoryCode) || ''}&${(s && s.cabinNumber) || ''}
    &${stateroom}&roomIndex=${s && s.roomIndex}${s && s.bookingReference ? `&bookingReference=${s.bookingReference}` : ''}`;
  });
  return `${itineraryId}&${stateroomsStr.join('&')}`;
};

export default getPriceBreakdownKey;
